export const puntosVentas = {
	"Plan 1": 7,
	"Plan 2": 13,
	"Plan 3": 13,
	"Plan 4": 15,
	"Plan 5": 11,
	"Plan 6": 13,
	"Plan 7": 13,
	"Plan 8": 15,
	"Dt Mensual": 6,
	"Dt Anual": 10,
	"Conta Básico": 9,
	"Conta Emprende": 10.5,
	"Conta Plan Pyme": 15.5,
	"Conta Remuneraciones": 9,
	"Pagina Web": 10,
	"Modif 1 dia": 12.5,
	"Modif Tradicional": 12.5,
	"Notificación SII": 4,
	Impresora: 10,
	Patente: 7,
	Otros: 3,
	"Renta Clientes": 5,
	"Renta No Clientes": 10,
	"Termino de Giro": 10,
	"Hab. Facturas": 10,
	"Hab. Boletas": 10,
	"Hab. Facturas + Boletas": 12.5,
	"Inicio Activ": 3,
	"Mandato": 13,
	"Contrato de Mutuo":13,
	"": 0,
};

export const serviciosVentas = [
	"Plan 1",
	"Plan 2",
	"Plan 3",
	"Plan 4",
	"Plan 5",
	"Plan 6",
	"Plan 7",
	"Plan 8",
	"Modif 1 dia",
	"Modif Tradicional",
	"Notificación SII",
	"Dt Mensual",
	"Dt Anual",
	"Conta Básico",
	"Conta Emprende",
	"Conta Plan Pyme",
	"Conta Remuneraciones",
	"Web",
	"Patente",
	"Otros",
	"Impresora",
	"Renta Clientes",
	"Renta No Clientes",
	"Termino de Giro",
	"Hab. Facturas",
	"Hab. Boletas",
	"Hab. Facturas + Boletas",
	"Inicio Activ",
	"Mandato",
	"Contrato de Mutuo"
];

